import Stack from '~/common/components/Stacks/Stack';
import Text from '~/common/components/Texts/Text';
import language from '~/common/constants/language.json';
import type { LoanSummary } from '~/common/hooks/useGetLoanSummary';
import Grid from '~/common/mui/Grids/GridItem';
import lang from '~/modals/LoanSummaryDialog/language.json';

import { LabelRowGroup, LabelText, TopLabel } from './Styled';

type LoanSummaryFHATabProps = Readonly<{
  loanInfo: LoanSummary['loanInfo'];
}>;
export function LoanSummaryFHATab({ loanInfo }: LoanSummaryFHATabProps) {
  return (
    <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row' }}>
      <Grid
        id="fha-info"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          mt: '1rem',
          minWidth: '340px',
          mr: '1.5rem',
        }}
      >
        <TopLabel>{lang.FHA_DETAILS}</TopLabel>
        <LabelRowGroup>
          <Stack direction="column">
            <LabelText>{lang.CASE_NUMBER}</LabelText>
            <Text>{loanInfo?.agencyCaseNumber ?? language.NOT_AVAILABLE}</Text>
          </Stack>
        </LabelRowGroup>
      </Grid>
    </Grid>
  );
}
